<template lang="pug">
div
  div.sticky-header-container
    div.pt-3(v-if="member.role === 'Admin'" :class="{ 'hidden-header': !showHeader, 'sticky-header': stickyFilter, }")
      v-row.d-flex.align-center(no-gutters)
        v-col
          v-tabs(v-model="dataType" color="textColorAccent" :height="40")
            v-tab.button-AA-medium {{ $t('donations') }}
            v-tab.button-AA-medium.mx-n3 {{ $t('leads') }}
            v-tab.button-AA-medium {{ $t('views') }}
        v-col.shrink
          v-btn.my-auto.mr-2(color="primary400" text height=32 @click="filterSheet = true" x-small)
            eva-icon(name="options-2-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="12")
            .label.ml-n1.primary400--text {{ $t('filter') }}
  v-row.mt-2.mb-0.mt-4(no-gutters)
    v-col(cols="12" v-if="member.role === 'Admin'")
      v-card(flat)
        div.text-center.mt-4
          .s1.primary500--text(v-if="chartName === 'sales'") {{ $t('total_donations') }}
          .s1.primary500--text(v-else) {{ $t('total') }} {{ chartName | titleCase }}
          .h5(v-if="metrics && chartName === 'sales'") {{ metrics[chartName].total | displayPrice }}
          .h5(v-else-if="metrics  && chartName !== 'sales'") {{ metrics[chartName].total | displayNumber }}
          .h6.primary500--text(v-else) -
          .c2.textColorHint--text(v-if="selectedFilter.range.id !== 'custom'") {{ selectedFilter.range.name.toUpperCase() }}
          .c2.textColorHint--text(v-else) {{ customDateFilterRangeFormatted }}
        apexchart(type="area" height="200", :options="chartOptions", :series="dataSeries")
  .modals
    filter-chart-sheet(v-if="filterSheet"
      :company="company"
      :filtered="selectedFilter"
      :open.sync="filterSheet"
      @filtered="handleFiltered")
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FilterChartSheet from './FilterChartSheet'

export default {
  name: 'SalesChart',
  components: { FilterChartSheet },
  props: ['company', 'stickyFilter'],
  data: () => ({
    showHeader: true,
    lastScrollPosition: 0,
    selectedFilter: {
      source: { name: 'All', id: '' },
      range: { name: 'This week', id: 'week' },
      selectedDateRange: []
    },
    customDateFilterMenu: false,
    customDateFilterRange: [],
    customDateFilterRangeFormatted: 'Date Range',
    filterSheet: false,
    filters: [
      {
        text: 'Day',
        value: 'day'
      },
      {
        text: 'Week',
        value: 'week'
      },
      {
        text: 'Month',
        value: 'month'
      },
      {
        text: 'Year',
        value: 'year'
      },
      {
        text: 'Date Range',
        value: 'custom'
      }
    ],
    dataType: 0,
    metrics: null
  }),
  computed: {
    ...mapState('user', ['member']),
    chartOptions () {
      return {
        colors: [this.$vuetify.theme.themes[this.$theme].basic600T40],
        chart: {
          fontFamily: 'Inter',
          height: '100%',
          toolbar: {
            show: false
          }
        },
        states: {
          active: {
            filter: {
              type: 'none'
            }
          }
        },
        grid: {
          show: true,
          strokeDashArray: 10,
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: false
        },
        fill: {
          type: 'solid'
        },
        yaxis: {
          labels: {
            formatter (value) {
              return isNaN(parseInt(value)) ? 100 : parseInt(value)
            }
          }
        },
        xaxis: {
          type: 'datetime',
          tooltip: {
            enabled: false
          },
          labels: {
            hideOverlappingLabels: true,
            datetimeUTC: false,
            datetimeFormatter: {
              year: 'yyyy',
              month: "MMM",
              day: 'dd/MM',
              hour: 'htt',
            }
          }
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          },
        }
      }
    },
    chartName () {
      if (this.dataType === 0) {
        return 'sales'
      } else if (this.dataType === 1) {
        return 'leads'
      } else  {
        return 'views'
      }
    },
    dataSeries () {
      let data = []
      const formatPoint = p => ({
        x: (new Date(p.point)).getTime(),
        y: this.chartName === 'sales' ? p.amount / 100 : p.amount
      })
      if (this.metrics) {
       data = this.metrics[this.chartName].points.map(p => formatPoint(p))
      }
      return [{
        name: this.$options.filters.capitalize(this.chartName),
        type: 'column',
        data
      }]
    },
    pointDateFormat () {
      if (this.selectedFilter.range.id === 'day') {
        return 'ha'
      } else if (this.selectedFilter.range.id === 'week') {
        return 'dd/MM'
      } else if (this.selectedFilter.range.id === 'month') {
        return 'd'
      } else if (this.selectedFilter.range.id === 'year') {
        return 'MMM'
      } else if (this.selectedFilter.range.id === 'custom') {
        if (this.selectedFilter.selectedDateRange.length === 2 && this.selectedFilter.selectedDateRange[0] === this.selectedFilter.selectedDateRange[1]) {
          return 'ha'
        } else {
          return 'dd/MM'
        }
      } else {
        return ''
      }
    },
    currentPointName () {
      if (this.selectedFilter.range.id === 'day') {
        return 'This hour'
      } else if (this.selectedFilter.range.id === 'week') {
        return 'This day'
      } else if (this.selectedFilter.range.id === 'month') {
        return 'This date'
      } else if (this.selectedFilter.range.id === 'year') {
        return 'This month'
      } else if (this.selectedFilter.range.id === 'custom') {
        if (this.selectedFilter.selectedDateRange.length === 2 && this.selectedFilter.selectedDateRange[0] === this.selectedFilter.selectedDateRange[1]) {
          return 'This hour'
        } else {
          return 'This date'
        }
      } else {
        return ''
      }
    }
  },
  watch: {
    company (val) {
      if (val) {
        this.fetchMetrics('week')
      }
    }
  },
  mounted () {
    this.fetchMetrics('week')
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleFiltered (data) {
      this.selectedFilter = data
      this.customDateFilterRangeFormatted = this.formatDateRange(data.selectedDateRange)
      this.fetchMetrics(data.range.id, data.selectedDateRange)
      this.$emit('spanChange', data)
    },
    formatDateRange (range) {
      if (range.length === 0) {
        return 'Date Range'
      } else if (range.length === 1) {
        const [year, month, day] = range[0].split('-')
        return `${day}/${month}/${year} -`
      } else {
        const [year1, month1, day1] = range[0].split('-')
        const [year2, month2, day2] = range[1].split('-')
        return `${day1}/${month1}/${year1} - ${day2}/${month2}/${year2}`
      }
    },
    fetchMetrics (span, range=null) {
      let url = `/companies/${this.company.id}/charts/?span=${span}`
      if (span === 'custom') {
        url = `/companies/${this.company.id}/charts/?span=custom&from=${range[0]}&until=${range[1]}`
      }
      this.$axios.get(url)
      .then(resp => {
        this.metrics = resp.data
      })
      .catch(e => {
        this.showMessage(['error', e.response.data[0]])
      })
    },
    onScroll () {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.showHeader = currentScrollPosition <= this.lastScrollPosition
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition
    }
  }
}
</script>

<style lang="scss" scoped>

.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  height: 52px;
}
.sticky-header {
  position: fixed;
  transition: 0.3s all ease-out;
  transform: translate3d(0, 0, 0) !important;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
}
.sticky-header.hidden-header{
  transform: translate3d(0, -100%, 0) !important;
}

</style>

<i18n>
{
  "en": {
    "donations": "Donations",
    "total_donations": "Total Donations"
  },
  "id": {
    "donations": "Donasi",
    "total_donations": "Jumlah Donasi"
  }
}
</i18n>